import * as Sentry from '@sentry/react';
const notificationAudio = new Audio('/notification.m4a');

export function playNotificationSound() {
  notificationAudio.currentTime = 0;
  notificationAudio.play().catch((err) => {
    console.warn('Could not play notification sound:', err);
    Sentry.captureException(err);
  });
}
